export default "__VITE_ASSET__CVwRhD4k__"